module.exports = require("./objectWithoutProperties.js");


//////////////////
// WEBPACK FOOTER
// ../~/babel-runtime/helpers/object-without-properties.js
// module id = 698
// module chunks = 1 3 4 5 6